import { render, staticRenderFns } from "./lkuPinjaman.vue?vue&type=template&id=b60bd8d0&"
import script from "./lkuPinjaman.vue?vue&type=script&lang=js&"
export * from "./lkuPinjaman.vue?vue&type=script&lang=js&"
import style0 from "./lkuPinjaman.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports